(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[521],{

/***/ 4613:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(2144);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppFooter */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);



var AppFooter = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "footer_container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "footer_about",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "about_us",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "about_logo",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                src: "/images/boom_logo.png",
                                alt: "Boom logo",
                                layout: "fill",
                                objectFit: "contain"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "about_info",
                            children: "Copyright \xa9 2021, BoomTV"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "about_links",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/terms",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "Terms and Conditions"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/privacy",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "Privacy"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/about",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "About"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/personal-data",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "Do Not Sell My Personal Information"
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AppFooter);


/***/ }),

/***/ 9735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppHeader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5617);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var contexts_app_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6777);
/* harmony import */ var contexts_viewport__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(369);
/* harmony import */ var redux_global_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3663);
/* harmony import */ var redux_event_lobby_slice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8279);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3135);












function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
var AppHeader = function(param) {
    var _transparent = param.transparent, transparent = _transparent === void 0 ? false : _transparent;
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)().asPath;
    var ref = (0,contexts_viewport__WEBPACK_IMPORTED_MODULE_8__/* .useViewport */ .Sj)(), isTwoColumnView = ref.isTwoColumnView, width = ref.width;
    var ref1 = _slicedToArray((0,contexts_app_context__WEBPACK_IMPORTED_MODULE_7__/* .useAppContext */ .b)(), 2), state = ref1[0], configDispatch = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isScrolling = ref2[0], setIsScrolling = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowingHamburger = ref3[0], setIsShowingHamburger = ref3[1];
    var currentScreen = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(redux_global_slice__WEBPACK_IMPORTED_MODULE_9__/* .selectors.currentScreen */ .wl.currentScreen);
    var eventTitle = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(redux_event_lobby_slice__WEBPACK_IMPORTED_MODULE_10__/* .selectors.eventTitle */ .wl.eventTitle);
    var goToHomePage = function() {
        window.location.href = '/';
    };
    var confirmGoToHomePage = function() {
        if (currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.EventLobby */ .wc.EventLobby || currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay) {
            configDispatch({
                type: 'SET_CONFIRM_MESSAGE',
                payload: 'Are you sure you want to return to the home page?'
            });
            configDispatch({
                type: 'SHOW_MODAL_CONFIRM',
                payload: true
            });
            configDispatch({
                type: 'SET_CONFIRM_ACTION',
                payload: goToHomePage
            });
        }
    };
    var showModalJoinOuting = function() {
        configDispatch({
            type: 'SHOW_MODAL_JOIN_OUTING',
            payload: true
        });
    };
    var isEventTitleVisible = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return currentScreen && currentScreen !== utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.Landing */ .wc.Landing && (isTwoColumnView || currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay);
    }, [
        isTwoColumnView,
        currentScreen
    ]);
    var toggleNavHamburger = function() {
        setIsShowingHamburger(!isShowingHamburger);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleScroll = function(e) {
            var offset = window.pageYOffset || document.documentElement.scrollTop;
            if (offset > 0) {
                setIsScrolling(true);
            } else {
                setIsScrolling(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return function() {
            return window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    var isWhiteNavbar = !transparent || isScrolling || isShowingHamburger;
    var isSmallLogoNeeded = (eventTitle === null || eventTitle === void 0 ? void 0 : eventTitle.length) > 20 && width < 650 && currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: 'nav_header' + (isWhiteNavbar ? ' white' : ''),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container nav_header_inner",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "block_left",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()('header_logo', {
                                    small: isSmallLogoNeeded
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                    passHref: true,
                                    href: currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.EventLobby */ .wc.EventLobby || currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay ? 'javascript:void(0)' : '/',
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                        src: isSmallLogoNeeded ? '/images/modal_logo.png' : isWhiteNavbar ? '/images/header/logo_white.png' : '/images/header/logo.png',
                                        alt: "Logo",
                                        layout: "fill",
                                        objectFit: "contain",
                                        onClick: confirmGoToHomePage
                                    })
                                })
                            }),
                            isEventTitleVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "nav_logo_text",
                                children: isSmallLogoNeeded ? "".concat(eventTitle.slice(0, 16), "...") : eventTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "block_right",
                        children: width > 650 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "nav_menu_container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "nav_menu",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                        href: "/help-details",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: "Help & Details"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "nav_menu",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                        href: "/contact-us",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: "Contact"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "nav_menu",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "nav_button",
                                        onClick: showModalJoinOuting,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: "Create Now"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "arrow_button"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "nav_menu_container",
                            children: isWhiteNavbar ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                src: "/images/header/hamburger_grey.png",
                                alt: "Hamburger",
                                width: 27,
                                height: 23,
                                onClick: toggleNavHamburger
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                src: "/images/header/hamburger.png",
                                alt: "Hamburger",
                                width: 27,
                                height: 23,
                                onClick: toggleNavHamburger
                            })
                        })
                    })
                ]
            }),
            width <= 650 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: 'nav_mobile_menu' + (isShowingHamburger ? ' show' : ''),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_shadow"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_mobile_section",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            href: "/help-details",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "Help & Details"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_mobile_section",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            href: "/contact-us",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "Contact"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_mobile_button",
                        onClick: showModalJoinOuting,
                        children: "Create Now"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AppHeader);


/***/ }),

/***/ 6413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IconClose */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var IconClose = function(param) {
    var _color = param.color, color = _color === void 0 ? '#2050C4' : _color;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11.2031",
                y: "5.24512",
                width: "1.08359",
                height: "8.12695",
                transform: "rotate(45 11.2031 5.24512)",
                fill: color
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "1.08359",
                height: "8.12695",
                transform: "matrix(-0.707107 0.707107 0.707107 0.707107 6.01562 5.24609)",
                fill: color
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "8.49032",
                cy: "8.49032",
                r: "7.03118",
                stroke: color,
                strokeWidth: "1.08172"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconClose);


/***/ }),

/***/ 8049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ModalJoinOuting; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var contexts_app_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6777);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1955);
/* harmony import */ var _icon_close__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6413);
/* harmony import */ var styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6280);
/* harmony import */ var styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6__);







function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function ModalJoinOuting() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''), displayName = ref[0], setDisplayName = ref[1];
    var ref1 = _slicedToArray((0,contexts_app_context__WEBPACK_IMPORTED_MODULE_3__/* .useAppContext */ .b)(), 2), state = ref1[0], dispatch = ref1[1];
    var showModalJoinOuting = state.showModalJoinOuting, passcodeModalJoinOuting = state.passcodeModalJoinOuting;
    var closeModalJoinOuting = function() {
        dispatch({
            type: 'SHOW_MODAL_JOIN_OUTING',
            payload: false
        });
    };
    var handleKeyDown = function(event) {
        if (event.key === 'Enter') {
            submit();
        }
    };
    var submit = function() {
        var inSixtyMinutes = new Date(new Date().getTime() + 60 * 60 * 1000);
        js_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"].set */ .Z.set('displayName', displayName === null || displayName === void 0 ? void 0 : displayName.trim(), {
            expires: inSixtyMinutes
        });
        if ((displayName === null || displayName === void 0 ? void 0 : displayName.trim()) && passcodeModalJoinOuting) {
            window.location.href = "/events/".concat(passcodeModalJoinOuting);
        } else {
            closeModalJoinOuting();
            if ((displayName === null || displayName === void 0 ? void 0 : displayName.trim()) && window.location.pathname !== '/landing') {
                window.location.href = '/landing';
            }
        }
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_message) + (showModalJoinOuting ? '' : ' hide'),
        id: "modal_join_outing",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_container),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_header),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_logo),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                src: "/images/modal_logo.png",
                                alt: "Team Games Logo",
                                width: 88,
                                height: 48
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_title),
                            children: "Join Outing"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_close),
                            onClick: closeModalJoinOuting,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_close__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_body),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().message_content),
                            style: {
                                display: 'block'
                            },
                            children: [
                                "Enter Your Name",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "text",
                                    className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().join_outing_input),
                                    placeholder: "Begin typing here",
                                    onChange: function(e) {
                                        return setDisplayName(e.target.value);
                                    },
                                    onKeyDown: handleKeyDown
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_actions),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_footer_btn),
                                onClick: submit,
                                children: "Submit"
                            })
                        })
                    ]
                })
            ]
        })
    }));
};


/***/ }),

/***/ 2144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var contexts_viewport__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(369);
/* harmony import */ var contexts_app_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6777);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3135);
/* harmony import */ var components_app_header__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9735);
/* harmony import */ var components_modals_modal_join_outing__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8049);
/* harmony import */ var components_app_footer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2695);
/* harmony import */ var styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(594);
/* harmony import */ var styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9__);










function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
var About = function() {
    var isMobile = (0,contexts_viewport__WEBPACK_IMPORTED_MODULE_3__/* .useViewport */ .Sj)().isMobile;
    var ref = _slicedToArray((0,contexts_app_context__WEBPACK_IMPORTED_MODULE_4__/* .useAppContext */ .b)(), 2), state = ref[0], dispatch = ref[1];
    var showModalJoinOuting = function() {
        dispatch({
            type: 'SHOW_MODAL_JOIN_OUTING',
            payload: true
        });
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().container),
        id: "about_page",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "About Team Games"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "/images/modal_logo.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TeamGamesMetaDescription */ .iO
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "og:image",
                        content: utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TeamGamesOGImagePath */ .Od
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().header_section),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_app_header__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        transparent: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().header_bg),
                        children: isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().header_bg_img),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                src: "/images/about/background_mobile.png",
                                alt: "Game for Every Team",
                                layout: "fill"
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().header_bg_img),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                src: "/images/about/background.png",
                                alt: "Game for Every Team",
                                layout: "fill"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().header_container),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().header_left),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: 'hero ' + (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().header_title),
                                        children: "Teams that Play Together Stay Together"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: 'description_small ' + (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().header_desc),
                                        children: "Professor J. Richard Hackman, an expert in organizational behavior, found that teamwork is most effective when it exists under certain “enabling conditions.” Those include: a compelling direction (goal), a strong structure, and a supportive context. Here at Team Games, we provide these conditions through entertaining games that you can play together anytime, anywhere. Team building exercises have never been this easy and fun!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().header_right),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().header_right_image_container),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                        src: "/images/about/header.png",
                                        alt: "Header",
                                        layout: "fill"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().metrics_section),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().metrics_section_bg_vector),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            src: "/images/about/metrics_bg_vector.png",
                            alt: "Metrics Background",
                            layout: "fill"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().metrics_section_cards),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().metrics_section_card),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().metrics_section_card_bg_container),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                            src: "/images/about/metrics_left.png",
                                            alt: "Card Image",
                                            width: 135,
                                            height: 152
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().metrics_section_card_number) + ' heading_1',
                                        children: "10000+"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().metrics_section_card_content) + ' description_large',
                                        children: "Teams brought together"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().metrics_section_card),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().metrics_section_card_bg_container),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                            src: "/images/about/metrics_center.png",
                                            alt: "Card Image",
                                            width: 169,
                                            height: 117
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().metrics_section_card_number) + ' heading_1',
                                        children: "10000+"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().metrics_section_card_content) + ' description_large',
                                        children: "Hours spent in virtual team Outings"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().metrics_section_card),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().metrics_section_card_bg_container),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                            src: "/images/about/metrics_right.png",
                                            alt: "Card Image",
                                            width: 165,
                                            height: 108
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().metrics_section_card_number) + ' heading_1',
                                        children: "8+"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().metrics_section_card_content) + ' description_large',
                                        children: "Games available now"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_text_left),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_left),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_title) + ' heading_1',
                                children: "Our Mission"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_content) + ' description_medium',
                                children: "When you schedule an Outing on Team Games, we pledge to make your team building experience easy, simple, and of course - fun - whether your company is divided by cubicles, oceans, or anything in between. Plus, things will never be the same once you discover Susan from accounting has got game. Here’s wishing you all the happiest surprises and friendly competition - from our team, to yours."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_right),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_right_image_container),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                src: "/images/about/misson.png",
                                alt: "Image",
                                layout: "fill"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_text_right),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_left),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_left_image_container),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                src: "/images/about/boom_to_teamgames.png",
                                alt: "Image",
                                layout: "fill"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_right),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_title) + ' heading_1',
                                children: "From BoomTV to Team Games"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_content) + ' description_medium',
                                children: [
                                    "BoomTV is a leading esports entertainment organizer with over 33,000 tournaments under our belt, and boy, do we have fun. But you don’t have to be a professional gamer to reap the benefits that video games offer. We believe every company deserves easy access to fun team building activities, so Team Games was born.",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                                    }),
                                    "There are over 2.7B people who enjoy video games, and most of them turn to quick, yet challenging game sessions on mobile. That’s because these games offer high rewards for low time investment. With Team Games, you can offer those same rewards with your organization."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_text_left),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_left),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_title) + ' heading_1',
                                children: "What Makes Us Different"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_content) + ' description_medium',
                                children: "The best solutions are often the simplest. That’s why we’ve designed team Outings to be scheduled in as little as 30 seconds. And, no software to download means you can jump in and out of the action on your schedule, not ours. Our games range from serious competition to silly fun, with new titles added all the time to keep things fresh. We hand-select each game to meet our standards of challenge and fun so that your Outings are the best they can be, every time. You can rely on Team Games to be there for you whenever you need us."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_right),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_right_image_container_2),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                src: "/images/about/difference.png",
                                alt: "Image",
                                layout: "fill"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_text_right_blue),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_text_right_blue_container),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_left),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_left_image_container),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                    src: "/images/about/love_your_team.png",
                                    alt: "Image",
                                    layout: "fill"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_right),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_title) + ' heading_1',
                                    children: [
                                        "We",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            width: "28",
                                            height: "26",
                                            viewBox: "0 0 28 26",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M27.1267 3.66903C25.9541 1.19196 22.5761 -0.834729 18.6467 0.345256C16.7691 0.903487 15.1309 2.10063 13.9998 3.74109C12.8687 2.10063 11.2305 0.903487 9.35287 0.345256C5.41479 -0.816714 2.04555 1.19196 0.872876 3.66903C-0.772366 7.13693 -0.0897655 11.0372 2.90317 15.2617C5.24852 18.5675 8.60026 21.9183 13.466 25.8095C13.6197 25.933 13.8092 26 14.0042 26C14.1992 26 14.3886 25.933 14.5424 25.8095C19.3994 21.9273 22.7598 18.6035 25.1052 15.2617C28.0894 11.0372 28.772 7.13693 27.1267 3.66903Z",
                                                fill: "white"
                                            })
                                        }),
                                        "Your Team"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mission_section_content) + ' description_medium',
                                    children: "If there’s one thing we’ve learned in all our years of organizing major esports tournaments it’s that skills don’t amount to much if you don’t have a strong team. You inspire us everyday with your creative schedules, on-the-fly problem solving, and the way you still manage to have fun. Team Games is here to support you whether you need to unwind or step up your game. Schedule an Outing today and let us do the heavy lifting. You’ve earned it."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().values_section),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().values_section_title) + ' heading_1',
                        children: "What we’re about"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().values_section_cards),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().values_section_card),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().values_section_card_bg_container),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                            src: "/images/about/values_left.png",
                                            alt: "Card Image",
                                            width: 185,
                                            height: 117
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().values_section_card_title) + ' heading_2',
                                        children: "Simplicity"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().values_section_card_desc) + ' description_small',
                                        children: "With Team Games, what you see is what you get. No extra software, no complicated systems. Just your team having a blast together."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().values_section_card),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().values_section_card_bg_container),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                            src: "/images/about/values_center.png",
                                            alt: "Card Image",
                                            width: 192,
                                            height: 128
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().values_section_card_title) + ' heading_2',
                                        children: "Adventure"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().values_section_card_desc) + ' description_small',
                                        children: "From Poker to Drawn Together, our growing list of games lets your team challenge themselves and try something new."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().values_section_card),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().values_section_card_bg_container),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                            src: "/images/about/values_right.png",
                                            alt: "Card Image",
                                            width: 138,
                                            height: 138
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().values_section_card_title) + ' heading_2',
                                        children: "Meaningful Work"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().values_section_card_desc) + ' description_small',
                                        children: "Today’s workforce wants to be part of something bigger. Team Games believes that work should bring people together, not separate them."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_bg_vector),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            src: "/images/about/team_bg_vector.png",
                            alt: "Bg",
                            layout: "fill"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_container),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_title) + ' heading_1',
                                children: "Meet the Team"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_desc) + ' description_large',
                                children: "Team Games is made up of diverse professionals from gaming, tech, sports, and more."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_cards),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "https://www.linkedin.com/in/guptasumit/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card_bg),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                                        src: "/images/about/profile/sumit.png",
                                                        alt: "Profile Image",
                                                        layout: "fill"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card_name) + ' heading_3',
                                                    children: "Sumit Gupta"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card_position) + ' heading_4',
                                                    children: "CEO"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card_bg)
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card_name) + ' heading_3',
                                                    children: "Ha Nguyen"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card_position) + ' heading_4',
                                                    children: "CTO"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "https://www.linkedin.com/in/garyfung/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card_bg),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                                        src: "/images/about/profile/gary_fung.jpg",
                                                        alt: "Profile Image",
                                                        layout: "fill"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card_name) + ' heading_3',
                                                    children: "Gary Fung"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card_position) + ' heading_4',
                                                    children: "Engineering"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "https://www.linkedin.com/in/christian-gross-esports/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card_bg),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                                        src: "/images/about/profile/christian.png",
                                                        alt: "Profile Image",
                                                        layout: "fill"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card_name) + ' heading_3',
                                                    children: "Christian Gross"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card_position) + ' heading_4',
                                                    children: "Product"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "https://twitter.com/DrulkTV",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card_bg),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                                        src: "/images/about/profile/dakota.png",
                                                        alt: "Profile Image",
                                                        layout: "fill"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card_name) + ' heading_3',
                                                    children: "Dakota Harding"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().team_section_card_position) + ' heading_4',
                                                    children: "Marketing"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section_cta),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section_cta_container),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section_cta_title) + ' hero',
                            children: "Get your team involved through Team Games"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section_cta_desc) + ' description_large',
                            children: "Discover the new way to build camaraderie and teamwork. Only at Team Games."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section_cta_buttons),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section_cta_button),
                                    onClick: showModalJoinOuting,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "Create Now"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().arrow)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section_cta_button) + ' ' + (styles_about_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section_cta_button_no_bg),
                                    onClick: function() {
                                        return location.href = '/contact-us';
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Contact Us"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modals_modal_join_outing__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_app_footer__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (About);


/***/ }),

/***/ 6280:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal_message":"modal_confirm_modal_message__iAMav","modal_container":"modal_confirm_modal_container__fW6ri","modal_header":"modal_confirm_modal_header__mRRXp","modal_logo":"modal_confirm_modal_logo__265lr","modal_title":"modal_confirm_modal_title__rgc0P","modal_close":"modal_confirm_modal_close__DzFM0","modal_body":"modal_confirm_modal_body__ZBCOc","message_content":"modal_confirm_message_content___bxgK","modal_actions":"modal_confirm_modal_actions__h17bb","join_outing_input":"modal_confirm_join_outing_input__tC0SX","feedback_error":"modal_confirm_feedback_error__J0_rb","modal_footer":"modal_confirm_modal_footer__HqmU5","confirm":"modal_confirm_confirm__Pv_Ug","modal_footer_btn":"modal_confirm_modal_footer_btn__cS1lI"};

/***/ }),

/***/ 594:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header_section":"about_header_section__Z_U15","header_bg":"about_header_bg__HE6qo","header_bg_img":"about_header_bg_img__DaPNB","header_container":"about_header_container___10JO","header_left":"about_header_left__NLJs2","header_title":"about_header_title__5Bhb_","header_desc":"about_header_desc__GQYzZ","header_right":"about_header_right__xzJu9","header_right_image_container":"about_header_right_image_container__0HNTS","metrics_section":"about_metrics_section__zzvXA","metrics_section_bg_vector":"about_metrics_section_bg_vector__vHMCV","metrics_section_cards":"about_metrics_section_cards__F02sH","metrics_section_card":"about_metrics_section_card__CrKdf","metrics_section_card_bg_container":"about_metrics_section_card_bg_container__7MmId","metrics_section_card_number":"about_metrics_section_card_number__ferR2","metrics_section_card_content":"about_metrics_section_card_content__0yY_F","mission_section_text_left":"about_mission_section_text_left__H7ekc","mission_section_left":"about_mission_section_left__o6mVf","mission_section_title":"about_mission_section_title__f8RPg","mission_section_right":"about_mission_section_right__OEOVY","mission_section_right_image_container":"about_mission_section_right_image_container__XAvQL","mission_section_right_image_container_2":"about_mission_section_right_image_container_2__5tGoR","mission_section_text_right":"about_mission_section_text_right__32wPF","mission_section_left_image_container":"about_mission_section_left_image_container__UErFb","mission_section_text_right_blue":"about_mission_section_text_right_blue__ZGttm","mission_section_text_right_blue_container":"about_mission_section_text_right_blue_container__m_7Fh","mission_section_content":"about_mission_section_content__KUbFq","values_section":"about_values_section__bWW7j","values_section_title":"about_values_section_title__PxpUI","values_section_cards":"about_values_section_cards__7o_5r","values_section_card":"about_values_section_card__JJ9RE","values_section_card_bg_container":"about_values_section_card_bg_container__caT3m","values_section_card_title":"about_values_section_card_title__Aazwf","values_section_card_desc":"about_values_section_card_desc__EmXwe","team_section":"about_team_section__ngGjm","team_section_bg_vector":"about_team_section_bg_vector__cXF1L","team_section_container":"about_team_section_container__gWSWQ","team_section_title":"about_team_section_title__oz1ai","team_section_desc":"about_team_section_desc__4VnpD","team_section_cards":"about_team_section_cards__vjAnO","team_section_card":"about_team_section_card__iJMgt","team_section_card_name":"about_team_section_card_name__alpDA","team_section_card_position":"about_team_section_card_position__7Mnco","team_section_card_bg":"about_team_section_card_bg__FBgmA","section_cta":"about_section_cta__ZdHao","section_cta_container":"about_section_cta_container__mXtyo","section_cta_title":"about_section_cta_title__UeBZv","section_cta_desc":"about_section_cta_desc__2SSH9","section_cta_buttons":"about_section_cta_buttons__WcLM2","section_cta_button":"about_section_cta_button__L747_","section_cta_button_no_bg":"about_section_cta_button_no_bg__pe_e9","arrow":"about_arrow__nyBKG"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [78,774,888,179], function() { return __webpack_exec__(4613); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);